<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- destory all the child components when the planState.boom is triggered
			didn't feel like nesting this -->
<ng-container *ngIf="!(shutdownSubject | async)">
	<crew-sizes></crew-sizes>
	<app-timeline-ticket-overflow></app-timeline-ticket-overflow>
	<constraint-pending-acceptance
		data-element-type="none"
		automationId="constraintPendingAcceptance"
	></constraint-pending-acceptance>

	<!--<dropdown-menu>-->
	<!--<div dropdown-label>-->
	<!--YO YO YO THIS MEH CUSTOM LABEL-->
	<!--</div>-->
	<!--<div dropdown-content>-->
	<!--YO YO YO THIS MEH CUSTOM CONTENT-->
	<!--</div>-->
	<!--</dropdown-menu>-->

	<!--<nav-bar>-->
	<!--<support-menu></support-menu>-->
	<!--</nav-bar>-->
	<!--<nav-bar-plan></nav-bar-plan>-->

	<plan-controller-component [planState]="planState"></plan-controller-component>
	<ng-container
		*ngIf="{
			selectedTickets: planState.tickets.selectedTicket$ | async,
			editTickets: planState.tickets.editTicket$ | async
		} as vmTickets"
	>
		<completed-selection-prompt
			*ngIf="
				(vmTickets.selectedTickets.statistics.completed.size && !vmTickets.editTickets.size) ||
				(vmTickets.selectedTickets.statistics.started.size && !vmTickets.editTickets.size)
			"
			(unselectCompleted)="
				onUnselectCompleted(
					planState.tickets.selectedTicket$.getValue().statistics.completed,
					planState.tickets.selectedTicket$.getValue().statistics.started
				)
			"
		></completed-selection-prompt>
	</ng-container>

	<!-- is there even a reason to use a swimlanes wrapper component? -->
	<swimlanes *ngIf="(planState.swimlanes?.data.editList$ | async)?.size"></swimlanes>

	<!-- CONTEXT MENUS -->
	<ticket-quick-status-prompt *ngIf="!(ticketEditPanelIsDisplayed$ | async)"></ticket-quick-status-prompt>
	<ticket-edit-context-menu *ngIf="!(ticketEditPanelIsDisplayed$ | async)"></ticket-edit-context-menu>
	<variance-prompt
		*ngIf="planState.ticketDragService.showVariancePrompt | async"
		[planPositioning]="planPromptPosition"
		class="on-plan-variance-prompt"
		[variance$]="planState.variances.list$"
		[shake$]="planState.shakeVariancePrompt$"
		(done)="
			planState.ticketDragService.applyVarianceFromPrompt(
				planState.tickets.selectedTicket$.getValue().list,
				$event
			)
		"
		(canceled)="
			planState.ticketDragService.cancelVariancePrompt(planState.tickets.selectedTicket$.getValue().list)
		"
	></variance-prompt>

	<!--  Ticket Edit Stuff -->
	<ticket-work-days-message class="ticket-work-days-container"></ticket-work-days-message>

	<ticket-edit-sheet
		*ngIf="ticketEditPanelIsDisplayed$ | async"
		class="ticket-edit-panel"
		[ngClass]="{ 'draft-area-visible': planState.scopeSoup.floatingRegionApi.isShown() }"
		[ticketContext]="ticketContext"
	></ticket-edit-sheet>

	<!-- Need to make sure planState.tickets are populated and thus available for multi select menu constructor. See TP-524 -->
	<multi-select-menu *ngIf="planState.tickets && planState.floatingTickets"></multi-select-menu>

	<!-- 'hide-hover' class to hide this component instead of using ngif is required because in this case Height observable and visibility observable have different purpose -->
	<hover-over-container
		[width]="300"
		[zIndex]="1000"
		[deadZoneSize]="0"
		[containerType]="hoverContainerType"
		[ngClass]="{ 'hide-hover': !(hoverOverStateService.combinedHoverVisibilityObservable$ | async) }"
	>
		<ticket-hover-contents
			*ngIf="hoverOverEnabled$ | async"
			[ticketData]="ticketHoverData$ | async"
			[settingsData]="hoverOverSettings$ | async"
			[imageAttachmentsCount]="hoverOverImageAttachmentsNumber$ | async"
			[isLoadingAttachmentsData]="isHoverLoadingAttachmentsData$ | async"
			[hoverOverCustomFieldsData]="hoverOverCustomFieldsData$ | async"
			(turnOffHoverOver)="onTurnOffHoverOver()"
			(showHoverOverSettings)="showHoverOverSettings(true)"
		></ticket-hover-contents>
	</hover-over-container>

	<undo-panel #undo *ngIf="undoEnabled$ | async"></undo-panel>

	<!-- <div *ngIf="planState.swimlanes.data.editList$ | async as editSwimlanes" (swimlanes)="editSwimlanes">
	<swimlane *ngFor="let swimData of editSwimlanes" (data)="swimData"></swimlane>
</div> -->

	<div *ngIf="showDockedTicket$ | async" class="docked-ticket-container full-height temp-dock">
		<docked-ticket
			[ticketId]="(tempDock.ticket$ | async).$id"
			[ticket$]="tempDock.dockedTicketSafeTicket$"
			[plan$]="planState.plan.object$"
			[roles$]="tempDock.role$"
			[locations$]="tempDock.location$"
			[projectMembers$]="tempDock.projectMember$"
			[priorityList$]="tempDock.prioritie$"
			[varianceList$]="tempDock.variance$"
			[ticketContext]="ticketContext"
			[customFieldsApi]="planState.customFieldsApi"
			[allowList$]="tempDock.allowList"
			[calendarWorkdays]="planState.calendarWorkdays"
			[planAccessCheck]="planAccessCheck"
			[disableForm]="false"
			(ticketDataChanged)="tempDock.ticketDataChanged($event)"
			(persistTicketData)="tempDock.persistTicketData($event)"
			(revertToDatabase)="tempDock.revertToDatabase($event)"
			(shouldClose)="tempDock.shouldClose($event)"
		>
		</docked-ticket>
	</div>

	<meeting-popup
		*ngIf="planState.showMeetingPopup"
		(closePopup)="planState.showMeetingPopup = false"
	></meeting-popup>
</ng-container>

<!-- Hover Over Settings -->
<hover-over-content-starter
	*ngIf="isHoverOverSettingsOpen"
	(afterClosed)="showHoverOverSettings(false)"
></hover-over-content-starter>

<tp-plan-filter-panel></tp-plan-filter-panel>

<tp-promise-now-button></tp-promise-now-button>
